<template>
	<div id="app">
		<Header />
		<div class="contents">
			<router-view />
		</div>
		<Footer />
		<carsuri-mark />
	</div>
</template>

<script>
import Header from '@/components/inc/Header'
import Footer from '@/components/inc/Footer'

import carsuriMark from '@/components/common/widget/CarsuriMark'
export default {
	name: 'App',
	data() {
		return {}
	},
	components: {
		Header,
		Footer,
		carsuriMark,
	},
}
</script>

<style scoped>
body {
	height: 100%;
}
#app {
	min-height: 100vh;
}
/* pc */
@media (min-width: 641px) {
	.contents {
		padding-top: 80px;
		padding-bottom: 120px;
	}
}
/* mobile */
@media (max-width: 640px) {
	.contents {
		padding-top: 60px;
		/* padding-bottom: 258px; */
	}
}
</style>



// WEBPACK FOOTER //
// src/App.vue